import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setCprPriorEmsArrival } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getCprPriorEmsArrivalOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getCprPriorEmsArrivalOptions])
    const { entity } = response
    yield put(setCprPriorEmsArrival(entity))
  } catch (e) {
    yield put(throwPcrException(`getCprPriorEmsArrivalOptions() error: ${e}`))
  }
}

export function* getCprPriorEmsArrivalOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCprPriorEmsArrivalOptions)
}
